// Venta cruzada «Completa tu instalación»: calcula cantidades con los m² de la calculadora y añade al carrito.
// Ficha: <mp-completa> escucha el evento mp:calc de flooring-calculator (m² reales con merma).
// Carrito: las filas ya traen la cantidad calculada en Liquid (data-qty); aquí solo se añade.
(() => {
  const eur = (cents) => (cents / 100).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
  const unitsText = (row, qty) => {
    const u = parseFloat(row.dataset.unit) || 1;
    const fmt = (n) => n.toLocaleString("es-ES", { maximumFractionDigits: 2 });
    if (row.dataset.mpUnitType === 'pack') return `${qty} pack${qty === 1 ? '' : 's'} A+B (${qty * 2} cajas)`;
    if (+row.dataset.boxSize > 1) { const n = qty / +row.dataset.boxSize; return `${n} caja${n > 1 ? "s" : ""} (${qty} tiras)`; }
    if (row.dataset.kind === "area") return u > 1 ? `${qty} rollo${qty > 1 ? "s" : ""} de ${fmt(u)} m²` : `${qty} m²`;
    if (row.dataset.kind === "perimetre") return `${qty} pieza${qty > 1 ? "s" : ""} de ${fmt(u)} m`;
    if (row.dataset.kind === "cobertura") return `${qty} ud.`;
    return `${qty} ud.`;
  };
  // Sin m² todavía: precio por m² o por metro (lo que se compara con el suelo) y, al lado, el del paquete.
  // Sin m² todavía: lo que se compra como mínimo (un rollo, una pieza, una caja).
  const packText = (row) => {
    if (row.dataset.mpUnitType === 'pack') return unitsText(row, 1);
    const u = parseFloat(row.dataset.unit) || 1;
    const fmt = (n) => n.toLocaleString("es-ES", { maximumFractionDigits: 2 });
    if (+row.dataset.boxSize > 1) return `Caja de ${row.dataset.boxSize} tiras`;
    if (row.dataset.kind === "area") return u > 1 ? `Rollo de ${fmt(u)} m²` : "";
    if (row.dataset.kind === "perimetre") return `Pieza de ${fmt(u)} m`;
    return unitsText(row, 1);
  };
  const grossPrimary = () => window.mpPriceMode === "gross";
  const shown = (row, cents) => grossPrimary() ? Math.round(cents * (100 + (+row.dataset.taxPct || 0)) / 100) : cents;
  const withVat = (row, cents, suffix = "") => {
    const pct = +row.dataset.taxPct;
    return pct > 0 ? (grossPrimary() ? ` (${eur(cents)}${suffix} + IVA)` : ` (${eur(Math.round(cents * (100 + pct) / 100))}${suffix} IVA incl.)`) : "";
  };
  const piecesFor = (row, m2) => {
    const u = parseFloat(row.dataset.unit) || 1;
    if (!m2 || m2 <= 0) return 1;
    if (row.dataset.kind === "area" || row.dataset.kind === "cobertura") return Math.max(1, Math.ceil((m2 * 1.05) / u - 1e-9));
    if (row.dataset.kind === "perimetre") return Math.max(1, Math.ceil((4 * Math.sqrt(m2) * 1.1) / u - 1e-9));
    return 1;
  };

  const roundBoxes = (row, qty) => {
    const size = Math.max(1, +row.dataset.boxSize || 1);
    return Math.ceil(Math.max(1, qty) / size) * size;
  };
  const qtyFor = (row, m2) => roundBoxes(row, piecesFor(row, m2));

  async function add(button) {
    const row = button.closest("[data-mp-cs-row]");
    const qty = roundBoxes(row, parseInt(row.dataset.qty, 10) || 1);
    let properties = +row.dataset.boxSize > 1 ? { _piezas: String(qty), _cajas: String(qty / +row.dataset.boxSize) } : {};
    if (window.MPLineQuantity) properties = window.MPLineQuantity.properties(properties, qty, {
      unitType: row.dataset.mpUnitType, mode: +row.dataset.mpM2 > 0 || row.dataset.mpUnitType === 'm2' ? 'm2' : 'ml', unitSize: +row.dataset.mpM2 || +row.dataset.mpMl || (row.dataset.mpUnitType === 'm2' ? 1 : 0), boxSize: +row.dataset.boxSize || 1,
    });
    button.disabled = true;
    button.textContent = "Añadiendo…";
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(row.dataset.variant), quantity: qty, properties }] }),
      });
      if (!res.ok) throw new Error(String(res.status));
      document.documentElement.dispatchEvent(new CustomEvent('mp:cart-add-success', { bubbles: true }));
      button.textContent = "Añadido";
      if (document.body.classList.contains("template-cart") || location.pathname.endsWith("/cart")) {
        location.reload();
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      const drawer = document.querySelector("cart-drawer");
      if (drawer && typeof drawer.show === "function") drawer.show();
    } catch (e) {
      button.disabled = false;
      button.textContent = "Reintentar";
    }
  }

  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-mp-cs-add]");
    if (b) { e.preventDefault(); add(b); }
  });

  if (!customElements.get("mp-completa")) {
    customElements.define("mp-completa", class extends HTMLElement {
      connectedCallback() {
        this.onCalc = (e) => this.update(e.detail && e.detail.m2);
        document.addEventListener("mp:calc", this.onCalc);
        this.collapse();
      }
      // Con más de dos opciones: a la vista lo necesario y el rodapié a juego (como mínimo dos filas);
      // el resto, plegado en «Ver N opciones más».
      collapse() {
        const rows = [...this.querySelectorAll("[data-mp-cs-row]")];
        if (rows.length <= 2 || this.querySelector("[data-mp-cs-more]")) return;
        const keep = new Set(this.querySelectorAll('[data-mp-cs-grup="necesario"] [data-mp-cs-row]'));
        const rod = this.querySelector('[data-mp-cs-grup="rodapie"] [data-mp-cs-row]');
        if (rod) keep.add(rod);
        for (const r of rows) { if (keep.size >= 2) break; keep.add(r); }
        const extra = rows.filter((r) => !keep.has(r));
        if (!extra.length) return;
        const groups = [...this.querySelectorAll("[data-mp-cs-grup]")];
        const setHidden = (hide) => {
          extra.forEach((r) => { r.hidden = hide; });
          groups.forEach((g) => { g.hidden = hide && ![...g.querySelectorAll("[data-mp-cs-row]")].some((r) => !r.hidden); });
        };
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "mp-cs__more";
        btn.setAttribute("data-mp-cs-more", "");
        btn.setAttribute("aria-expanded", "false");
        const label = () => (btn.getAttribute("aria-expanded") === "true"
          ? "Ver menos"
          : `Ver ${extra.length} ${extra.length === 1 ? "opción" : "opciones"} más`);
        btn.textContent = label();
        btn.addEventListener("click", () => {
          const open = btn.getAttribute("aria-expanded") !== "true";
          btn.setAttribute("aria-expanded", String(open));
          setHidden(!open);
          btn.textContent = label();
        });
        const lastGroup = groups[groups.length - 1];
        (lastGroup || this).after(btn);
        setHidden(true);
      }
      disconnectedCallback() { document.removeEventListener("mp:calc", this.onCalc); }
      update(m2) {
        const sub = this.querySelector("[data-mp-cs-sub]");
        if (sub) sub.textContent = m2 > 0
          ? `Cantidades para tus ${m2.toLocaleString("es-ES", { maximumFractionDigits: 2 })} m²`
          : "Indica tus m² y calculamos las cantidades";
        this.querySelectorAll("[data-mp-cs-row]").forEach((row) => {
          const qty = qtyFor(row, m2);
          row.dataset.qty = qty;
          const perUnit = Boolean(row.dataset.unitLabel);
          const known = m2 > 0;
          const tax = grossPrimary() ? "IVA incl." : row.dataset.taxLabel;
          const total = qty * parseInt(row.dataset.price, 10);
          const q = row.querySelector("[data-mp-cs-qty]");
          const p = row.querySelector("[data-mp-cs-price]");
          const vat = row.querySelector("[data-mp-cs-vat]");
          if (vat) vat.hidden = !(+row.dataset.taxPct > 0);
          if (perUnit) {
            // Bases y rodapiés: grande por m²/ml; el importe entero del paquete o de tus m², debajo del nombre.
            const unit = parseInt(row.dataset.unitPrice, 10) || 0;
            if (p) p.textContent = `${eur(shown(row, unit))}/${row.dataset.unitLabel} ${tax}`;
            if (vat) vat.textContent = withVat(row, unit, `/${row.dataset.unitLabel}`).trim();
            const base = known ? unitsText(row, qty) : packText(row);
            if (q) q.textContent = base ? `${base}: ${eur(shown(row, total))} ${tax}${withVat(row, total)}` : "Se vende por m²";
          } else {
            if (q) q.textContent = unitsText(row, qty);
            if (p) p.textContent = `${eur(shown(row, total))} ${tax}`;
            if (vat) vat.textContent = withVat(row, total).trim();
          }
          const b = row.querySelector("[data-mp-cs-add]"); if (b && b.textContent !== "Añadiendo…") { b.disabled = false; b.textContent = "Añadir"; }
        });
      }
    });
  }
})();
